import React from 'react';
import { GROUP_STATUSES, GROUP_STATUS_LABEL } from '../utils/requestGroups';

// Summary tiles (Total / Pending / Partially Approved / Approved / Rejected)
// over the endpoint's statusCounts. Clicking a tile selects that tab.
// TODO(#9 follow-up): Partially Approved tile toggle pending a settings flag.
function RequestSummaryTiles({ counts = {}, value, onChange }) {
    const total = GROUP_STATUSES.reduce((a, k) => a + (Number(counts[k]) || 0), 0);
    const tiles = [{ key: '', label: 'Total Requests', count: total }].concat(
        GROUP_STATUSES.map((k) => ({ key: k, label: GROUP_STATUS_LABEL[k], count: Number(counts[k]) || 0 }))
    );
    return (
        <div className="request-tiles">
            {tiles.map((t) => (
                <button key={t.key || 'ALL'} type="button"
                    className={`request-tile ${value === t.key ? 'active' : ''}`}
                    onClick={() => onChange(t.key)}>
                    <div className="request-tile__count">{t.count}</div>
                    <div className="request-tile__label">{t.label}</div>
                </button>
            ))}
        </div>
    );
}

export default RequestSummaryTiles;
